import { useEffect, useState } from "react";

interface useMustationObserverProps { }

export const useMutationObserver = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const [ observees, setObservees] = useState<{id: String, observer: MutationObserver}[]>([]);
    /* ******************** Functions ******************** */
    const observe = (observee: Node, id: string, handler: (props?: any) => any) => {  
        if (observees.some( o => o.id === id)) {
            console.log('observer already exists')
            return;
        }    
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node instanceof Element) {
                            handler(node)
                        }
                    });
                }
            });
        });

        observer.observe(observee, {
            childList: true, // observe direct children
            subtree: true, // and lower descendants too
        });
        console.log(`Observing ${id}...`)
        const newObservees = Array.from(observees);
        newObservees.push({
            id,
            observer
        })
        setObservees(newObservees)
    }
    const disconnect = (id?: string) =>{
        if (id) {
            const idx = observees.findIndex( o => o.id === id);
            if (idx >= 0) {
                observees[idx].observer.disconnect();
                console.log(`${observees[idx].id} observer disconnected`);
                const newObservees = Array.from(observees);
                newObservees.splice(idx, 1)
                setObservees(newObservees);
            }
            return;
        }
        observees.forEach( o =>{
            o.observer.disconnect();
            setObservees([]);
        })
        console.log(`All observers disconnected`)
    }
    /* ******************** Effects ******************** */
    useEffect(() =>{
        return disconnect();
    }, [])
    /* ******************** JSX ******************** */
    return {
        observe,
        observees,
        disconnect
    }
}